<template>
  <div class="login">
    <h1 class="section-title">
      {{ $t("forget password") }}
    </h1>
    <van-form @submit="onSubmit">
      <van-field
        v-model="email"
        :name="$t('email')"
        :label="$t('email')"
        :placeholder="$t('email')"
        :rules="[{ required: true, message: $t('email is required') }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          {{ $t("reset password") }}
        </van-button>
      </div>
      <div class="center-me">
        <router-link :to="{ name: 'login' }" style="padding-left:5px;">
          {{ $t("login") }}
        </router-link>
        /
        <router-link :to="{ name: 'register' }" style="padding-left:5px;">
          {{ $t("register") }}
        </router-link>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "ForgetPassword",
  data() {
    return {
      email: ""
    };
  },
  methods: {
    ...mapActions("account", ["forgetPasswordReset"]),
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    onSubmit() {
      const { email } = this;
      this.forgetPasswordReset({ email });
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("forget password"));
  }
};
</script>
